import React from "react";
import { FaUsers, FaChartLine } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { FaBullseye, FaLightbulb } from "react-icons/fa";
import { isMobile } from "react-device-detect";
const timelineData = [
  {
    year: "2011",
    title: "Commencement of Business",
    description: "Transaction Analysts officially commenced operations in the digital payment sector.",
    note: "Marked the beginning of our journey to empower digital India.",
    icon: "🏁",
    color: "#3b82f6",
    iconBg: "#eff6ff",
  },
  {
    year: "2012",
    title: "NPCI Certification Partner",
    description: "Recognized as an official certification partner by NPCI.",
    note: "Enabled us to support secure and scalable transaction systems.",
    icon: "✅",
    color: "#10b981",
    iconBg: "#ecfdf5",
  },
  {
    year: "2014",
    title: "RBI PPI License & Fintech Stack Launch",
    description: "Secured RBI PPI license and launched innovative Fintech India Stack.",
    note: "Strengthened digital wallet offerings and regulatory compliance.",
    icon: "💳",
    color: "#f59e0b",
    iconBg: "#fffbeb",
  },
  {
    year: "2016",
    title: "Microsoft Acceleration Program",
    description: "Selected for Microsoft’s startup acceleration program.",
    note: "Provided access to global cloud infrastructure and support.",
    icon: "🚀",
    color: "#8b5cf6",
    iconBg: "#f5f3ff",
  },
  {
    year: "2017",
    title: "India’s First State Citizen Wallet Launched",
    description: "Launched the first state-level digital wallet for citizens.",
    note: "A milestone in public digital payment access.",
    icon: "📲",
    color: "#ef4444",
    iconBg: "#fee2e2",
  },
  {
    year: "2018",
    title: "10 Lakh+ Users Onboarded",
    description: "Over 10,00,000 wallets and users successfully registered.",
    note: "Major adoption milestone across the country.",
    icon: "👥",
    color: "#14b8a6",
    iconBg: "#ccfbf1",
  },
  {
    year: "2020",
    title: "RuPay/UPI & FastTag Solutions Launched",
    description: "Expanded offerings to include RuPay, UPI, and FastTag digital payment solutions.",
    note: "Driving faster, secure and interoperable transactions.",
    icon: "🔗",
    color: "#eab308",
    iconBg: "#fef9c3",
  },
  {
    year: "2022",
    title: "Launch of API Banking",
    description: "Introduced API Banking to accelerate digital transformation for clients.",
    note: "Enabled faster integration and smarter workflows.",
    icon: "🔌",
    color: "#0ea5e9",
    iconBg: "#e0f2fe",
  },
  {
    year: "2024",
    title: "Rajasthan DBT & UPI Initiatives",
    description:
      "Implemented Rajasthan State DBT schemes like TA PAY, TA PAYX, TA ONE APP, UPI PPI, and TPAP.",
    note: "Empowering state-level digital disbursements and inclusion.",
    icon: "🏛️",
    color: "#6366f1",
    iconBg: "#e0e7ff",
  },
];

const EmpowerSection = () => {
  const styles = {
    page: {
      fontFamily: "'Segoe UI', sans-serif",
      // background: "linear-gradient(to bottom right, #f4fdf8, #ffffff)",
      padding: "20px  0px 30px 0px  ",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      alignItems: "center",
    },
    left: {
      flex: 1,
      minWidth: "300px",
   
    },
    heading: {
      fontSize: "43px",
      fontWeight: 700,
      color: "#0f172a",
      lineHeight: "1.2",
      marginBottom: "20px",
    },
    highlight: {
      color: "#059669",
    },
    description: {
      fontSize: "18px",
      color: "#475569",
      marginBottom: "30px",
      maxWidth: "500px",
    },
    tags: {
      display: "flex",
      gap: "16px",
      flexWrap: "wrap",
      marginBottom: "30px",
    },
    tag: {
      display: "flex",
      alignItems: "center",
      background: "#ffffff",
      padding: "10px 18px",
      borderRadius: "30px",
      boxShadow: "0 5px 10px rgba(0,0,0,0.05)",
      fontSize: "16px",
      fontWeight: "500",
      color: "#0f172a",
    },
    tagIcon: {
      color: "#059669",
      marginRight: "8px",
    },
    buttons: {
      display: "flex",
      gap: "16px",
      flexWrap: "wrap",
    },
    rightImage: {
  flex: 1,
  display: "flex",
  justifyContent: "end",
  alignItems: "end",
  marginRight:"50px"
  // padding: "20px",
},
    primaryButton: {
      display: "flex",
      alignItems: "center",
      padding: "14px 24px",
      borderRadius: "30px",
      background: "#059669",
      color: "#ffffff",
      fontWeight: "600",
      fontSize: "16px",
      border: "none",
      boxShadow: "0 5px 10px rgba(0,0,0,0.15)",
      cursor: "pointer",
    },
    outlineButton: {
      display: "flex",
      alignItems: "center",
      padding: "14px 24px",
      borderRadius: "30px",
      border: "2px solid #059669",
      background: "#ffffff",
      color: "#059669",
      fontWeight: "600",
      fontSize: "16px",
      cursor: "pointer",
    },
    rightCard: {
      flex: 1,
      minWidth: "350px",
      maxWidth: "600px",
      background: "#ffffff",
      borderRadius: "20px",
      padding: "30px",
      boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
      position: "relative",
    },
    iconRow: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "30px",
    },
    iconBox: {
      flex: 1,
      marginRight: "20px",
    },
    iconCircle: {
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      background: "#d1fae5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "10px",
    },
    icon: {
      color: "#059669",
      fontSize: "24px",
    },
    line1: {
      height: "10px",
      width: "90%",
      background: "#bbf7d0",
      borderRadius: "6px",
      marginBottom: "8px",
    },
    line2: {
      height: "10px",
      width: "70%",
      background: "#e2e8f0",
      borderRadius: "6px",
    },
    barRow: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: "20px",
      gap: "10px",
    },
    bar: {
      flex: 1,
      height: "40px",
      background: "linear-gradient(to bottom, #4ade80, #22c55e)",
      borderRadius: "8px",
      boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
    },
    cornerTop: {
      position: "absolute",
      top: "-14px",
      right: "-14px",
      width: "32px",
      height: "32px",
      backgroundColor: "#86efac",
      opacity: 0.4,
      transform: "rotate(45deg)",
      borderRadius: "8px",
    },
    cornerBottom: {
      position: "absolute",
      bottom: "-14px",
      left: "-14px",
      width: "32px",
      height: "32px",
      backgroundColor: "#86efac",
      opacity: 0.4,
      transform: "rotate(45deg)",
      borderRadius: "8px",
    },
  };

 const containerStyle = {
    backgroundColor: "#ffffff",
    padding: "60px 20px",
    textAlign: "center",
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
  };

  const headerTitleStyle = {
    fontSize: "32px",
    fontWeight: "700",
    color: "#1f2937",
    marginBottom: "10px",
  };

  const headerSubTitleStyle = {
    fontSize: "18px",
    color: "#6b7280",
    marginBottom: "40px",
  };

  const cardsContainerStyle = {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "30px",
  };

  const cardBaseStyle = {
    width: "550px",
    borderRadius: "16px",
    backgroundColor: "#ffffff", // Default white background
    border: "1px solid #bdfbb9ff",
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.1)",
    padding: "50px 70px",
    textAlign: "center",
    transition: "all 0.3s ease", // Smooth transition for hover
  };

  const iconStyle = {
    backgroundColor: "#a7f3d0",
    width: "70px",
    height: "70px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 20px",
  };

  const cardTitleStyle = {
    fontSize: "30px",
    fontWeight: "700",
    color: "#1f2937",
    marginBottom: "15px",
  };

  const cardTextStyle = {
    fontSize: "18px",
    color: "#6b7280",
    marginBottom: "20px",
    lineHeight: "1.6",
  };

  const highlightStyle = {
    color: "#16a34a",
    fontWeight: "600",
  };

  const badgeStyle = {
    display: "inline-block",
    padding: "6px 14px",
    borderRadius: "9999px",
    fontSize: "14px",
    fontWeight: "500",
    backgroundColor: "#bbf7d0",
    color: "#16a34a",
  };

  // Hover handlers
  const handleMouseEnter = (e) => {
    e.currentTarget.style.transform = "translateY(-5px)";
    e.currentTarget.style.boxShadow = "0 12px 40px rgba(0, 0, 0, 0.15)";
    e.currentTarget.style.backgroundColor = "#f0fdf4"; // Light green on hover
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "0 8px 30px rgba(0, 0, 0, 0.1)";
    e.currentTarget.style.backgroundColor = "#ffffff"; // Back to white
  };

  const container = {
    backgroundColor: "#f9fafb",
    // padding: "60px 20px",
    textAlign: "center",
    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
  };

  const headerTitle = {
    fontSize: "32px",
    fontWeight: "700",
    color: "#1f2937",
    marginBottom: "10px",
  };

  const headerSubtitle = {
    fontSize: "18px",
    color: "#6b7280",
    marginBottom: "40px",
  };
const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "20px", // better spacing between cards
  justifyItems: "center",

};


const baseCard = {
  width: "100%",
  maxWidth: "400px",
  borderRadius: "16px",
  backgroundColor: "#ffffff",
  border: "1px solid #e5e7eb",
  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
  padding: "30px 20px",
  textAlign: "left",
  transition: "all 0.3s ease",
  cursor: "pointer",
};


  const baseIconWrapper = {
    width: "50px",
    height: "50px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
    transition: "all 0.3s ease",
  };

  const title = {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1f2937",
    marginBottom: "10px",
  };

  const text = {
    fontSize: "18px",
    color: "#6b7280",
    lineHeight: "1.6",
  };
const cards = [
  {
    title: "We Respect and Uphold Trust",
    text:
      "We respect everybody and operate with transparency, reliability, and trustworthiness in everything we do.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="#3b82f6" width="24" height="24" viewBox="0 0 24 24">
        <path d="M12 0l8 4v4c0 5.53-3.806 10.74-9 12-5.194-1.26-9-6.47-9-12V4l10-4z" />
      </svg>
    ),
    iconBg: "#dbeafe",
    hoverCardBg: "#eff6ff",
    hoverIconBg: "#bfdbfe",
  },
  {
    title: "We Perform with Integrity",
    text:
      "We perform every task with integrity, ethics, and passion — always committed to doing what’s right.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="#ef4444" width="24" height="24" viewBox="0 0 24 24">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      </svg>
    ),
    iconBg: "#fee2e2",
    hoverCardBg: "#fff5f5",
    hoverIconBg: "#fecaca",
  },
  {
    title: "We Take Ownership",
    text:
      "We accept personal responsibility for everything we do and consistently lead by example.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="#16a34a" width="24" height="24" viewBox="0 0 24 24">
        <path d="M12 12c2.761 0 5-2.238 5-5s-2.239-5-5-5-5 2.238-5 5 2.239 5 5 5zm0 2c-3.866 0-7 3.134-7 7h2c0-2.757 2.243-5 5-5s5 2.243 5 5h2c0-3.866-3.134-7-7-7z" />
      </svg>
    ),
    iconBg: "#d1fae5",
    hoverCardBg: "#f0fdf4",
    hoverIconBg: "#a7f3d0",
  },
  {
    title: "We Empower Teamwork",
    text:
      "We empower our associates to create value through collaboration, creativity, and strong team spirit.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="#facc15" width="24" height="24" viewBox="0 0 24 24">
        <path d="M13 2v2h-2V2h2zm6.364 1.636l-1.414 1.414L19.586 6l1.414-1.414-1.636-1.636zM22 11h-2v2h2v-2zm-1.636 6.364l-1.414-1.414L18 17.586l1.414 1.414 1.636-1.636zM13 20v2h-2v-2h2zm-6.364-1.636l1.414-1.414L4.414 16 3 17.414l1.636 1.636zM2 13H0v-2h2v2zm1.636-6.364L5.05 8.05 6 7.1 4.586 5.686 3.636 6.636z" />
        </svg>
    ),
    iconBg: "#fef9c3",
    hoverCardBg: "#fefce8",
    hoverIconBg: "#fde68a",
  },
  {
    title: "We Delight Our Clients",
    text:
      "We strive to deliver a delightful client experience that goes beyond expectations and builds lasting relationships.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="#8b5cf6" width="24" height="24" viewBox="0 0 24 24">
        <path d="M12 0L9.5 6.5H3l5.2 3.8L6.6 16 12 12.4 17.4 16l-1.6-5.7L21 6.5h-6.5z" />
      </svg>
    ),
    iconBg: "#ede9fe",
    hoverCardBg: "#f5f3ff",
    hoverIconBg: "#ddd6fe",
  },
  {
    title: "We Champion Digital Inclusion",
    text:
      "We promote 'less cash' societies by enabling secure and user-friendly digital transactions for everyone.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill="#10b981" width="24" height="24" viewBox="0 0 24 24">
        <path d="M12 1l9 4v5c0 5.25-3.375 10.375-9 12C6.375 20.375 3 15.25 3 10V5l9-4z" />
      </svg>
    ),
    iconBg: "#d1fae5",
    hoverCardBg: "#ecfdf5",
    hoverIconBg: "#a7f3d0",
  },
];

  return (
    <>
    <div
      style={{
        background: "linear-gradient(135deg, #fcf8e5ff, #ecfdf5)",
        paddingBottom: "30px",
        paddingTop: "40px",
      }}
    >
      <section
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 20px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "60px",
            flexDirection: window.innerWidth < 768 ? "column" : "row",
            textAlign: window.innerWidth < 768 ? "center" : "left",
          }}
        >
          {/* Left Content */}
          <div style={{ flex: 1 }}>
            <h1
              style={{
                fontSize: window.innerWidth < 768 ? "1.9rem" : "2.5rem",
                fontWeight: 700,
                color: "#111827",
                lineHeight: 1.3,
              }}
            >
              Empowering{" "}
              <span style={{ color: "#1f8c50" }}>Digital Payments</span>
              <br /> for a Better Tomorrow
            </h1>
            <p
              style={{
                fontSize: "16px",
                color: "#4b5563",
                marginTop: "20px",
              }}
            >
              Driving inclusive financial growth through secure and scalable
              solutions that transform how the world transacts.
            </p>

            <div
              style={{
                display: "flex",
                flexDirection: window.innerWidth < 768 ? "column" : "row",
                gap: "16px",
                marginTop: "30px",
                alignItems: window.innerWidth < 768 ? "center" : "flex-start",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "16px",
                  color: "#1f2937",
                  backgroundColor: "#fff",
                  borderRadius: "30px",
                  padding: "10px 20px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                }}
              >
                <FaUsers style={{ color: "#1f8c50" }} /> Expert Team
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "16px",
                  color: "#1f2937",
                  backgroundColor: "#fff",
                  borderRadius: "30px",
                  padding: "10px 20px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                }}
              >
                <FaChartLine style={{ color: "#1f8c50" }} /> Growth Focused
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: window.innerWidth < 768 ? "column" : "row",
                gap: "16px",
                marginTop: "30px",
                alignItems: window.innerWidth < 768 ? "center" : "flex-start",
              }}
            >
              <button
                style={{
                  backgroundColor: "#1f8c50",
                  color: "#fff",
                  border: "none",
                  borderRadius: "999px",
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() =>
                  document
                    .getElementById("vision-section")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
              >
                Explore Our Vision{" "}
                <IoIosArrowForward style={{ marginLeft: "8px" }} />
              </button>

              <button
                style={{
                  backgroundColor: "transparent",
                  color: "#1f8c50",
                  border: "2px solid #1f8c50",
                  borderRadius: "999px",
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => (window.location.href = "/boardmembers")}
              >
                <FaUsers style={{ marginRight: "8px" }} /> Meet Our Team
              </button>
            </div>
          </div>

          {/* Right Content */}
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: window.innerWidth < 768 ? "30px" : "0",
            }}
          >
            <img
              src="/assets/images/aboutimg.png"
              alt="Digital Payments"
              style={{
                width: "100%",
                maxWidth: window.innerWidth < 768 ? "260px" : "340px",
              }}
            />
          </div>
        </div>
      </section>
    </div>

    <div  id="vision-section" style={containerStyle}>
      <div>
        <h2 style={headerTitleStyle}>Our Vision & Mission</h2>
        <p style={headerSubTitleStyle}>
          Guiding principles that drive our commitment to digital transformation
        </p>
      </div>

      <div style={cardsContainerStyle}>
        {/* Vision Card */}
        <div
          style={cardBaseStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div style={iconStyle}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              fill="#16a34a"
              viewBox="0 0 24 24"
            >
              <path d="M12 2C6.477 2 2 6.484 2 12s4.477 10 10 10 10-4.484 10-10S17.523 2 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
            </svg>
          </div>
          <h3 style={cardTitleStyle}>Vision Statement</h3>
          <p style={cardTextStyle}>
           Accelerate Digital Transformation & Financial Inclusion  with Innovative
Payment Platforms Products & Solutions​
          </p>
          <div style={badgeStyle}>● Future-Focused</div>
        </div>

        {/* Mission Card */}
        <div
          style={cardBaseStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div style={iconStyle}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              fill="#16a34a"
              viewBox="0 0 24 24"
            >
              <path d="M12 2a10 10 0 0 0-1 19.95V22h2v-.05A10 10 0 0 0 12 2zm1 17h-2v-2h2v2zm0-4h-2V7h2v8z" />
            </svg>
          </div>
          <h3 style={cardTitleStyle}>Mission Statement</h3>
          <p style={cardTextStyle}>
          To improve Quality of life of every citizen by providing easy to use
simple, secure and cost effective Digital Payment Products and
Solutions
          </p>
          <div style={badgeStyle}>● Action-Oriented</div>
        </div>
      </div>
    </div>
    <section className="container">
  <div
    style={{
      padding: "40px 20px",
      textAlign: "center",
    }}
  >
    <h2
      style={{
        fontSize: "2rem",
        marginBottom: "10px",
      }}
    >
      Our Core Values
    </h2>
    <p
      style={{
        fontSize: "1rem",
        color: "#6b7280",
        marginBottom: "30px",
      }}
    >
      The principles that guide everything we do and shape our company culture
    </p>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "24px",
        justifyContent: "center",

        // ✅ Mobile styles
        ...(window.innerWidth <= 768
          ? {
              gridTemplateColumns: "1fr",
              gap: "16px",
            }
          : {}),
      }}
    >
      {cards.map((card, index) => {
        const iconWrapper = {
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          backgroundColor: card.iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.3s ease",
          marginBottom: "16px",
        };

        return (
          <div
            key={index}
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              padding: "20px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
              transition: "all 0.3s ease",
              cursor: "pointer",
              textAlign: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = card.hoverCardBg;
              e.currentTarget.querySelector("div").style.backgroundColor = card.hoverIconBg;
              e.currentTarget.querySelector("div").style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffffff";
              e.currentTarget.querySelector("div").style.backgroundColor = card.iconBg;
              e.currentTarget.querySelector("div").style.transform = "scale(1)";
            }}
          >
            <div style={iconWrapper}>{card.icon}</div>
            <h3 style={{ fontSize: "1.2rem", fontWeight: "600", marginBottom: "8px" }}>{card.title}</h3>
            <p style={{ fontSize: "0.95rem", color: "#4b5563" }}>{card.text}</p>
          </div>
        );
      })}
    </div>
  </div>
</section>

 <section
      style={{
        backgroundColor: "#f9fafb",
        padding: "60px 20px",
        fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
        textAlign: "center",
      }}
    >
      <h2
        style={{
          fontSize: "32px",
          fontWeight: "700",
          color: "#1f2937",
          marginBottom: "10px",
        }}
      >
        Our Journey
      </h2>
      <p style={{ fontSize: "16px", color: "#6b7280", marginBottom: "50px" }}>
        Steady growth and expansion to deliver value across the digital payments
        ecosystem
      </p>

      <div
        style={{
          position: "relative",
          maxWidth: "1100px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: "20px", // exact spacing as in your image
        }}
      >
        {/* Vertical Line */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "50%",
            width: "2px",
            height: "100%",
            backgroundColor: "#10b981",
            transform: "translateX(-50%)",
            zIndex: 1,
          }}
        ></div>

        {timelineData.map((item, index) => {
          const isLeft = index % 2 === 0;

          return (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: isLeft ? "flex-end" : "flex-start",
                alignItems: "center",
                position: "relative",
                width: "100%",
              }}
            >
              {/* Timeline Dot */}
              <span
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  backgroundColor: item.color,
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 2,
                  boxShadow: "0 0 0 6px white",
                }}
              ></span>

              {/* Card */}
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.05)",
                  padding: "32px",
                  maxWidth: "460px",
                  textAlign: "left",
                  zIndex: 3,
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {/* Top Row */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span
                    style={{
                      backgroundColor: item.iconBg,
                      color: item.color,
                      fontSize: "30px",
                      borderRadius: "12px",
                      padding: "2px",
                      display: "inline-block",
                    }}
                  >
                    {item.icon}
                  </span>
                  <div
                    style={{
                      backgroundColor: "#ecfdf5",
                      color: "#047857",
                      fontSize: "18px",
                      fontWeight: 600,
                      padding: "4px 12px",
                      borderRadius: "999px",
                    }}
                  >
                    {item.year}
                  </div>
                  
                </div>

                {/* Title */}
                <h3
                  style={{
                    fontSize: "25px",
                    fontWeight: "700",
                    color: "#1f2937",
                  }}
                >
                  {item.title}
                </h3>

                {/* Description */}
                <p
                  style={{
                    fontSize: "16px",
                    color: "#4b5563",
                    lineHeight: "1.6",
                  }}
                >
                  {item.description}
                </p>

                {/* Note Box */}
                <div
                  style={{
                    fontSize: "13px",
                    color: "#6b7280",
                    backgroundColor: "#f9fafb",
                    padding: "8px 12px",
                    borderRadius: "8px",
                    display: "inline-block",
                  }}
                >
                  {item.note}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>


    <section
  style={{
    background: "linear-gradient(to right, #047857, #059669)",
    padding: "80px 20px",
    color: "#fff",
    textAlign: "center",
    fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
  }}
>
  <h2
    style={{
      fontSize: "40px",
      fontWeight: "700",
      marginBottom: "10px",
    }}
  >
    Looking to <span style={{ color: "#ffffff" }}>Deliver</span>{" "}
    <span style={{ color: "#a7f3d0" }}>Frictionless</span> <br />
    <span style={{ color: "#a7f3d0" }}>Payments?</span>
  </h2>

  <p
    style={{
      fontSize: "18px",
      color: "#d1fae5",
      margin: "20px 0 40px",
      maxWidth: "700px",
      marginLeft: "auto",
      marginRight: "auto",
    }}
  >
    Accelerate Your Digital Transformation with TA Solutions – where innovation
    meets reliability
  </p>

  <div style={{ display: "flex", justifyContent: "center" }}>
   <button
  onClick={() => (window.location.href = "/contactus")}
  style={{
    display: "flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: "white",
    color: "#059669",
    border: "none",
    padding:"10px",
    borderRadius: "999px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  }}
>
  <span style={{ fontSize: "18px" }}>📞</span>
  Contact Us Now <span style={{ fontSize: "18px" }}>→</span>
</button>

  </div>
</section>

    </>
    
  );
};

export default EmpowerSection;
